/**
 * Vuex mutations for the zoom module.
 *
 * @module store/modules/zoom/mutations
 */
import Vue from "vue";
import { MutationTree } from "vuex/types";

import { ZoomState } from "./types";

const mutations: MutationTree<ZoomState> = {
  /**
   * Sets or updates a Zoom meeting for a specific user.
   *
   * @param {ZoomState} state - Module state
   * @param {Object} payload - Meeting data
   * @param {string} payload.user_id - User ID
   * @param {string} payload.meeting_id - Zoom meeting ID
   * @param {string} payload.start_url - Host start URL
   * @param {string} payload.join_url - Participant join URL
   */
  SET_ZOOM_MEETING: (state, payload) => {
    Vue.set(state.meetings, payload.user_id, payload)
  }
};

export default mutations;
